// // src/components/CreateUserModal.js
// import { useState } from "react";

// export default function CreateUserModal({ onClose, onCreate }) {
//   const [formData, setFormData] = useState({
//     // User fields
//     username: "",
//     email: "",
//     first_name: "",
//     last_name: "",
//     age: "",

//     // Preferences
//     gender: "female",
//     ethnicity: "",
//     customer_persona: "",
//     promotion_propensity: "medium",
//     clothing_size: "M",
//     footwear_size: "8",
//     color_preference: "",
//     color_tone_preference: "medium",
//     apparel_preference: "dresses",
//     graphical_appearance_preference: "solid",
//     fabric_preference: "",
//     fit_preference: "regular",
//     clothing_budget_preference: "premium",
//     accessory_preference: "watch",
//     accessory_budget_preference: "premium",
//   });

//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     let val = type === "checkbox" ? checked : value;

//     // Convert numeric fields
//     if (["age", "footwear_size"].includes(name)) {
//       val = val === "" ? "" : Number(val);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: val,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setIsLoading(true);

//     try {
//       const userData = {
//         user: {
//           username: formData.username,
//           email: formData.email,
//           first_name: formData.first_name,
//           last_name: formData.last_name,
//           age: formData.age,
//         },
//         preferences: {
//           first_name: formData.first_name,
//           gender: formData.gender,
//           ethnicity: formData.ethnicity,
//           customer_persona: formData.customer_persona,
//           promotion_propensity: formData.promotion_propensity,
//           clothing_size: formData.clothing_size,
//           footwear_size: formData.footwear_size,
//           color_preference: formData.color_preference,
//           color_tone_preference: formData.color_tone_preference,
//           apparel_preference: formData.apparel_preference,
//           graphical_appearance_preference: formData.graphical_appearance_preference,
//           fabric_preference: formData.fabric_preference,
//           fit_preference: formData.fit_preference,
//           clothing_budget_preference: formData.clothing_budget_preference,
//           accessory_preference: formData.accessory_preference,
//           accessory_budget_preference: formData.accessory_budget_preference,
//         },
//       };

//       await onCreate(userData);
//       onClose();
//     } catch (err) {
//       setError(err.message || "Failed to create user");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//       <div className="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg shadow-lg p-6">
//         <div className="flex justify-between items-center mb-6">
//           <h2 className="text-2xl font-bold text-gray-900">Create New User</h2>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-700 text-2xl"
//             aria-label="Close"
//           >
//             &times;
//           </button>
//         </div>

//         {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{error}</div>}

//         <form onSubmit={handleSubmit} className="space-y-6">
//           {/* === User Information === */}
//           <section>
//             <h3 className="text-lg font-semibold text-gray-800 mb-3">User Account</h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Username *</label>
//                 <input
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
//                 <input
//                   name="email"
//                   type="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
//                 <input
//                   name="first_name"
//                   value={formData.first_name}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
//                 <input
//                   name="last_name"
//                   value={formData.last_name}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Age</label>
//                 <input
//                   name="age"
//                   type="number"
//                   min="0"
//                   value={formData.age}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             </div>
//           </section>

//           {/* === Preferences === */}
//           <section>
//             <h3 className="text-lg font-semibold text-gray-800 mb-3">User Preferences</h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {/* Text inputs */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Ethnicity</label>
//                 <input
//                   name="ethnicity"
//                   value={formData.ethnicity}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                   placeholder="e.g., African American"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Customer Persona</label>
//                 <input
//                   name="customer_persona"
//                   value={formData.customer_persona}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Color Preference</label>
//                 <input
//                   name="color_preference"
//                   value={formData.color_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Fabric Preference</label>
//                 <input
//                   name="fabric_preference"
//                   value={formData.fabric_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>

//               {/* Selects */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
//                 <select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="female">Female</option>
//                   <option value="male">Male</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Promotion Propensity</label>
//                 <select
//                   name="promotion_propensity"
//                   value={formData.promotion_propensity}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="low">Low</option>
//                   <option value="medium">Medium</option>
//                   <option value="high">High</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Clothing Size</label>
//                 <select
//                   name="clothing_size"
//                   value={formData.clothing_size}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   {["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL"].map((size) => (
//                     <option key={size} value={size}>{size}</option>
//                   ))}
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Footwear Size</label>
//                 <input
//                   name="footwear_size"
//                   type="number"
//                   step="0.5"
//                   min="0"
//                   value={formData.footwear_size}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Color Tone Preference</label>
//                 <select
//                   name="color_tone_preference"
//                   value={formData.color_tone_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="light">Light</option>
//                   <option value="medium">Medium</option>
//                   <option value="dark">Dark</option>
//                   <option value="bright">Bright</option>
//                   <option value="dusty_light">Dusty Light</option>
//                   <option value="medium_dusty">Medium Dusty</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Apparel Preference</label>
//                 <input
//                   name="apparel_preference"
//                   value={formData.apparel_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Graphical Appearance</label>
//                 <select
//                   name="graphical_appearance_preference"
//                   value={formData.graphical_appearance_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="solid">Solid</option>
//                   <option value="pattern">Pattern</option>
//                   <option value="stripe">Stripe</option>
//                   <option value="check">Check</option>
//                   <option value="transparent">Transparent</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Fit Preference</label>
//                 <input
//                   name="fit_preference"
//                   value={formData.fit_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Clothing Budget</label>
//                 <select
//                   name="clothing_budget_preference"
//                   value={formData.clothing_budget_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="budget">Budget</option>
//                   <option value="premium">Premium</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Accessory Preference</label>
//                 <input
//                   name="accessory_preference"
//                   value={formData.accessory_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Accessory Budget</label>
//                 <select
//                   name="accessory_budget_preference"
//                   value={formData.accessory_budget_preference}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="budget">Budget</option>
//                   <option value="premium">Premium</option>
//                 </select>
//               </div>
//             </div>
//           </section>

//           {/* === Actions === */}
//           <div className="flex justify-end gap-3 pt-4 border-t">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 font-medium"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={isLoading}
//               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium disabled:opacity-50"
//             >
//               {isLoading ? "Creating User..." : "Create User"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// src/components/CreateUserModal.js
import { useState } from "react";

export default function CreateUserModal({ onClose, onCreate }) {
  const [formData, setFormData] = useState({
    // User fields
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    age: "",
    // ✅ NEW user fields
    address: "",
    address_tag: "Apartment", // default as per your example
    payment_detail: "PayPal", // default as per your example

    // Preferences
    gender: "female",
    ethnicity: "",
    customer_persona: "",
    promotion_propensity: "medium",
    clothing_size: "M",
    footwear_size: "8",
    color_preference: "",
    color_tone_preference: "medium",
    apparel_preference: "dresses",
    graphical_appearance_preference: "solid",
    fabric_preference: "",
    fit_preference: "regular",
    clothing_budget_preference: "premium",
    accessory_preference: "watch",
    accessory_budget_preference: "premium",
  });

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = type === "checkbox" ? checked : value;

    // Convert numeric fields
    if (["age", "footwear_size"].includes(name)) {
      val = val === "" ? "" : Number(val);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const userData = {
        user: {
          username: formData.username,
          email: formData.email,
          first_name: formData.first_name,
          last_name: formData.last_name,
          age: formData.age,
          // ✅ Include new fields in user object
          address: formData.address,
          address_tag: formData.address_tag,
          payment_detail: formData.payment_detail,
        },
        preferences: {
          first_name: formData.first_name,
          gender: formData.gender,
          ethnicity: formData.ethnicity,
          customer_persona: formData.customer_persona,
          promotion_propensity: formData.promotion_propensity,
          clothing_size: formData.clothing_size,
          footwear_size: formData.footwear_size,
          color_preference: formData.color_preference,
          color_tone_preference: formData.color_tone_preference,
          apparel_preference: formData.apparel_preference,
          graphical_appearance_preference: formData.graphical_appearance_preference,
          fabric_preference: formData.fabric_preference,
          fit_preference: formData.fit_preference,
          clothing_budget_preference: formData.clothing_budget_preference,
          accessory_preference: formData.accessory_preference,
          accessory_budget_preference: formData.accessory_budget_preference,
        },
      };

      await onCreate(userData);
      onClose();
    } catch (err) {
      setError(err.message || "Failed to create user");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Create New User</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* === User Information === */}
          <section>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">User Account</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Username *</label>
                <input
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                <input
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
                <input
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
                <input
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Age</label>
                <input
                  name="age"
                  type="number"
                  min="0"
                  value={formData.age}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* ✅ NEW FIELDS */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                <input
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="e.g. 2459 Pinewood Dr, Austin, TX 73301"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Address Type</label>
                <input
                  name="address_tag"
                  value={formData.address_tag}
                  onChange={handleChange}
                  placeholder="e.g. Apartment, Office, Home"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Payment Method</label>
                <input
                  name="payment_detail"
                  value={formData.payment_detail}
                  onChange={handleChange}
                  placeholder="e.g. PayPal, Credit Card"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </section>

          {/* === Preferences === */}
          <section>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">User Preferences</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* ... (rest of your preferences remain unchanged) ... */}

              {/* (Keep all existing preference fields exactly as they are) */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ethnicity</label>
                <input
                  name="ethnicity"
                  value={formData.ethnicity}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  placeholder="e.g., African American"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Customer Persona</label>
                <input
                  name="customer_persona"
                  value={formData.customer_persona}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Color Preference</label>
                <input
                  name="color_preference"
                  value={formData.color_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fabric Preference</label>
                <input
                  name="fabric_preference"
                  value={formData.fabric_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  <option value="female">Female</option>
                  <option value="male">Male</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Promotion Propensity</label>
                <select
                  name="promotion_propensity"
                  value={formData.promotion_propensity}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Clothing Size</label>
                <select
                  name="clothing_size"
                  value={formData.clothing_size}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  {["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL"].map((size) => (
                    <option key={size} value={size}>{size}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Footwear Size</label>
                <input
                  name="footwear_size"
                  type="number"
                  step="0.5"
                  min="0"
                  value={formData.footwear_size}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Color Tone Preference</label>
                <select
                  name="color_tone_preference"
                  value={formData.color_tone_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  <option value="light">Light</option>
                  <option value="medium">Medium</option>
                  <option value="dark">Dark</option>
                  <option value="bright">Bright</option>
                  <option value="dusty_light">Dusty Light</option>
                  <option value="medium_dusty">Medium Dusty</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Apparel Preference</label>
                <input
                  name="apparel_preference"
                  value={formData.apparel_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Graphical Appearance</label>
                <select
                  name="graphical_appearance_preference"
                  value={formData.graphical_appearance_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  <option value="solid">Solid</option>
                  <option value="pattern">Pattern</option>
                  <option value="stripe">Stripe</option>
                  <option value="check">Check</option>
                  <option value="transparent">Transparent</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fit Preference</label>
                <input
                  name="fit_preference"
                  value={formData.fit_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Clothing Budget</label>
                <select
                  name="clothing_budget_preference"
                  value={formData.clothing_budget_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  <option value="budget">Budget</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Accessory Preference</label>
                <input
                  name="accessory_preference"
                  value={formData.accessory_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Accessory Budget</label>
                <select
                  name="accessory_budget_preference"
                  value={formData.accessory_budget_preference}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                >
                  <option value="budget">Budget</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
            </div>
          </section>

          {/* === Actions === */}
          <div className="flex justify-end gap-3 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium disabled:opacity-50"
            >
              {isLoading ? "Creating User..." : "Create User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}